module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//snow_4_3.png?v=5b5c8510";